import meter1 from "../assets/img/warmepumpe.png";
import meter2 from "../assets/img/energieklasse.png";
import meter3 from "../assets/img/co2.png";
import meter4 from "../assets/img/batterie.png";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import arrow1 from "../assets/img/arrow1.svg";
import arrow2 from "../assets/img/arrow2.svg";

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1200 },
      items: 3,
      partialVisibilityGutter: 0
    },
    desktop: {
      breakpoint: { max: 1200, min: 768 },
      items: 2,
      partialVisibilityGutter: 0
    },
    tablet: {
      breakpoint: { max: 768, min: 520 },
      items: 2,
      partialVisibilityGutter: 0
    },
    mobile: {
      breakpoint: { max: 520, min: 0 },
      items: 1,
      partialVisibilityGutter: 0 
    }
};

return (
  <section className="skill anchor-offset" id="skills">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className="skill-bx wow zoomIn">
            <h2>Vorteile</h2>
            <p>Wir zeigen dir, wie du mit deinem Zuhause Energie und Geld sparst<br /> Schritt für Schritt und ganz individuell</p>
              <Carousel
                responsive={responsive}
                infinite={true}
                arrows={true}
                partialVisible={false}
                showDots={false}
                className="owl-carousel owl-theme skill-slider"
              >
                <div className="item">
                  <img src={meter1} alt="Image" />
                  <h5>Bis zu 70% Förderung <br />bei Wärmepumpen</h5>
                </div>
                <div className="item">
                  <img src={meter2} alt="Image" />
                  <h5>Bis zu 5% Förderung dank <br />individuellem Sanierungsfahrplan</h5>
                </div>
                <div className="item">
                  <img src={meter3} alt="Image" />
                  <h5>CO₂ Einsparungen</h5>
                </div>
                <div className="item">
                  <img src={meter4} alt="Image" />
                  <h5>Kosteneinsparung durch <br />Verbrauchsminimierung</h5>
                </div>
              </Carousel>
          </div>
        </div>
      </div>
    </div>
  </section>
)
}